import React from "react";
import { useTranslation } from "../../shared/translation/Translation";
import WarningPrompt from "./WarningPrompt";

const ScreenSharingWarningPrompt: React.FC = () => {
    const messages = useTranslation();
    const isPrivate = window.location.search.includes("businessLine=private");

    return (
        <WarningPrompt
            message={
                isPrivate
                    ? messages.screenSharingWarningPrompt.privateContent
                    : messages.screenSharingWarningPrompt.defaultContent
            }
        ></WarningPrompt>
    );
};

export default ScreenSharingWarningPrompt;
